import React from 'react';
import PropTypes from 'prop-types';
import PDPCustomerPhotosGridUI from './PDPCustomerPhotosGridUI';

const PDPCustomerPhotosGrid = ({ photos, totalPhotos, onPhotoClick }) => (
  <PDPCustomerPhotosGridUI
    photos={photos}
    totalPhotos={totalPhotos}
    onPhotoClick={onPhotoClick}
  />
);

PDPCustomerPhotosGrid.propTypes = {
  photos: PropTypes.array,
  totalPhotos: PropTypes.number,
  onPhotoClick: PropTypes.func,
};

export default PDPCustomerPhotosGrid;
